import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({
  children,
  roles = [],
  excludeRoles = [],
  redirectTo = "/",
}) => {
  const userRole = localStorage.getItem("user_role");

  if (roles.length > 0 && !roles.includes(userRole)) {
    return <Navigate to={redirectTo} replace />;
  }

  if (excludeRoles.includes(userRole)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default ProtectedRoute;